export type DeliveryChannel = 'email' | 'whatsapp';
export interface DeliveryOutcome { channel: DeliveryChannel; signer?: number; error?: string; delivered: boolean; deepLink?: string; }
export interface DeliveryRetryPlan { channels: DeliveryChannel[]; retryTargets?: Array<{ signer: number; channel: DeliveryChannel }>; }

/** A shared channel remains selected until every intended recipient on it succeeds. */
export function deliveryRetryPlan(outcomes: readonly DeliveryOutcome[]): DeliveryRetryPlan | null {
  const failed = outcomes.filter((outcome) => outcome.error || (!outcome.delivered && !outcome.deepLink));
  if (!failed.length) return null;
  const channels = [...new Set(failed.map((outcome) => outcome.channel))];
  if (failed.every((outcome) => outcome.signer != null)) {
    const targets = new Map(failed.map((outcome) => [`${outcome.signer}:${outcome.channel}`, { signer: outcome.signer!, channel: outcome.channel }]));
    return { channels, retryTargets: [...targets.values()] };
  }
  return { channels };
}

/** Bind signer retries to the document revision that produced their failed outcomes. */
export function deliveryRetryFields(plan: DeliveryRetryPlan | null, selected: DeliveryChannel[], expectedRevision?: number): { retryTargets?: Array<{ signer: number; channel: DeliveryChannel }>; expectedRevision?: number } {
  if (!plan?.retryTargets) return {};
  return { retryTargets: plan.retryTargets.filter((target) => selected.includes(target.channel)), ...(expectedRevision != null ? { expectedRevision } : {}) };
}
